export var TrialBalanceDateOption;
(function (TrialBalanceDateOption) {
    TrialBalanceDateOption["Today"] = "today";
    TrialBalanceDateOption["EndThisMonth"] = "endThisMonth";
    TrialBalanceDateOption["EndLastMonth"] = "endLastMonth";
    TrialBalanceDateOption["EndLastQuarter"] = "endLastQuarter";
    TrialBalanceDateOption["EndLastFinancialYear"] = "endLastFinancialYear";
    TrialBalanceDateOption["Custom"] = "custom";
})(TrialBalanceDateOption || (TrialBalanceDateOption = {}));
export var TrialBalanceGroupByOption;
(function (TrialBalanceGroupByOption) {
    TrialBalanceGroupByOption["GlAccount"] = "glAccount";
    TrialBalanceGroupByOption["TransactionType"] = "transactionType";
})(TrialBalanceGroupByOption || (TrialBalanceGroupByOption = {}));
//# sourceMappingURL=index.js.map